package site.shadadman.pages.worklog.bit24cash

import androidx.compose.runtime.*
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.data.*
import com.varabyte.kobweb.core.layout.Layout
import com.varabyte.kobweb.core.layout.NoLayout
import com.varabyte.kobweb.core.init.InitRoute
import com.varabyte.kobweb.core.init.InitRouteContext
import com.varabyte.kobwebx.frontmatter.*
import com.varabyte.kobwebx.markdown.*

@InitRoute
fun initMar182026bit24AWarHasBegonPage(ctx: InitRouteContext) {
    ctx.data.add(MarkdownContext("worklog/bit24cash/mar182026bit24AWarHasBegon.md", FrontMatterElement.EmptyMap))
}

@Page("/worklog/bit24cash/mar182026bit24-a-war-has-begon")
@Composable
fun Mar182026bit24AWarHasBegonPage() {
    org.jetbrains.compose.web.dom.H2(attrs = { id("mar-18-2026-bit24-a-war-has-began") }) {
        org.jetbrains.compose.web.dom.Text("mar-18-2026-bit24-A-War-Has-Began")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("At  mar 2026 our government had shutdown internet on its people. The longest shutdown not just in countries history but in the world. Nothing could stop this holey Islamic evil. This monstress mafia called IRGC ;comparing to Hitler but much worth; that Trump says in one of its speech. We could only access to vitrificated domain proved by government. No Google, No GitHub. No Maven, No Twitter, No Instagram. Completely blinded from outside world.")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("censorship is the golden key to a strong dictatorship. As in the movie The Dictator, it’s said ‘When you’re a dictator, you don’t need to apologize. You just take what you want!‘")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("People had to travel long distances to countries like Turkey or Iraq just to check an email, can you believe that in 2026? Families had no word from loved ones abroad, some had travelers who vanished from contact, leaving them in agony, unsure if they had arrived safely.")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("I was missing my work so much, typing code, my GitHub, being with my colleagues, and seeing those successful Gradle builds in Android Studio.")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("I cannot imagine any government doing this to its own people. Even during wartime, countries usually recognize that access to the internet is needed more than ever.")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("One thing I can blame for the current situation is ‘Shariat.’ Religion, especially Islam, combined with politics has created this monsters that has ruined us, destroyed our lives, and devastated our country and futures. I was once a good Muslim, but now I absolutely hate that word with all my heart. I am filled with disgust by it.")
    }
}
